module.exports = __webpack_public_path__ + "img/nft.b9764707.png";